import React ,{useState} from "react";
import { ConfigProvider } from "antd";
import { lightTheme } from "./theme";
import NavigationManager from "./NavigationManager";

const App = () => {
    
  return (
    <>
      {/* <Helmet> */}
        {/* <title>{title}</title> */}
        {/* <link rel="icon" type="image/png" href={faviconUrl} /> */}
      {/* </Helmet> */}
      <ConfigProvider theme={lightTheme}>
        <NavigationManager />
      </ConfigProvider>
    </>
  );
};

export default App;
